import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { isLoggedIn, doLogOut} from '../services/user.service'; // Adjust the import path as necessary
import { is } from 'date-fns/locale';

const AutoLogout = ({ timeout = 5 * 60 * 1000 }) => {
  const navigate = useNavigate();
  const timer = useRef<number | null>(null);

  const ACTIVITY_KEY = 'lastActivity';
  const LOGOUT_KEY = 'logout-event';

  const logout = () => {
    localStorage.removeItem('user'); // Clear your auth token/session here
    localStorage.setItem(LOGOUT_KEY, Date.now().toString());
    //alert('Logged out due to inactivity.');
    const token = localStorage.getItem('TOKEN');
    if(token){
      doLogOut();
      document.location.href = "/login";
    }
  };

  const resetTimer = () => {
    // Broadcast new activity timestamp
    localStorage.setItem(ACTIVITY_KEY, Date.now().toString());
    startTimer();
  };

  const startTimer = () => {
    if (timer.current) clearTimeout(timer.current);

    timer.current = window.setTimeout(() => {
      logout();
    }, timeout);
    
  };

  useEffect(() => {
    const handleActivity = () => {
      resetTimer();
    };

    const handleStorage = (e: any) => {
      if (e.key === ACTIVITY_KEY) {
        startTimer(); // activity in another tab
      }

      if (e.key === LOGOUT_KEY) {
        logout(); // logout in another tab
      }
    };

    const events = ['mousemove', 'keydown', 'click', 'scroll'];
    events.forEach((event) => window.addEventListener(event, handleActivity));
    window.addEventListener('storage', handleStorage);

    resetTimer(); // initialize

    return () => {
      events.forEach((event) => window.removeEventListener(event, handleActivity));
      window.removeEventListener('storage', handleStorage);
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  return null;
};

export default AutoLogout;
